const nonEmpty = (v) => {
  if (v == null) return "";
  const s = String(v).trim();
  return s || "";
};

/**
 * Pick en/ar from a { en, ar } object with locale-first fallback.
 */
export const localizedFromEnAr = (nameObj, isRTL) => {
  if (nameObj == null) return "";
  if (typeof nameObj === "string") return nonEmpty(nameObj);
  if (typeof nameObj !== "object") return "";
  const en = nonEmpty(nameObj.en);
  const ar = nonEmpty(nameObj.ar);
  if (isRTL) return ar || en;
  return en || ar;
};

/**
 * Product title: prefer product_details.name, then productNameEn/Ar, name, product_id.
 */
export const getOrderLineProductName = (product, isRTL) => {
  const fromDetails = localizedFromEnAr(product?.product_details?.name, isRTL);
  if (fromDetails) return fromDetails;
  const pen = nonEmpty(product?.productNameEn);
  const par = nonEmpty(product?.productNameAr);
  const pname = nonEmpty(product?.name);
  if (isRTL) return par || pen || pname || String(product?.product_id ?? "");
  return pen || par || pname || String(product?.product_id ?? "");
};

export const getModifierGroupLabel = (modifier, isRTL) => {
  const en = nonEmpty(modifier?.nameEn);
  const ar = nonEmpty(modifier?.nameAr);
  if (isRTL) return ar || en;
  return en || ar;
};

export const getModifierOptionLabel = (option, isRTL) => {
  const en = nonEmpty(option?.nameEn);
  const ar = nonEmpty(option?.nameAr);
  if (isRTL) return ar || en;
  return en || ar;
};

/** Modifier row: "Group: Option" when both exist, else whichever is present. */
export const getModifierLineDisplayLabel = (modifier, option, isRTL) => {
  const group = getModifierGroupLabel(modifier, isRTL);
  const opt = getModifierOptionLabel(option, isRTL);
  if (group && opt) return `${group}: ${opt}`;
  return opt || group || "";
};

export const escapeHtmlText = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
